<template>
  <div>
    <Dialog v-if="state.visible" :modelValue="props.modelValue" @update:modelValue="updateModelValue" type="common" :showClose="false">
      <div class="dialog" :class="cssType">
        <div class="dialog-title">
          {{ $t('payment.tip') }}
        </div>
        <div class="dialog-content">
          <div>
            {{ data.type === 'ended' ? $t('payment.ended') : $t('payment.notStart') }}
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, watch, reactive, nextTick } from 'vue'
import { isMobile } from '@/utils'
import Dialog from '@/components/Dialog/ActCny/index.vue'
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object,
    default: () => {}
  },
  cb: {
    type: Function,
    default: () => {}
  }
})

const state = reactive({
  visible: false
})

watch(() => props.modelValue, (newVal) => {
  nextTick(() => {
    state.visible = newVal
  })
}, {
  immediate: true
})

const emit = defineEmits(['update:modelValue'])

const updateModelValue = (value) => {
  emit('update:modelValue', value)
  props.cb && props.cb(value)
}



</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
